import React, { useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import CustomButton from './Button';
import { useTranslation } from 'react-i18next';

const ContactForm = () => {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [question, setQuestion] = useState('');
  const [err, setError] = useState({});
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [submitStatus, setSubmitStatus] = useState();


  const {t} = useTranslation();

  const submit = () => {
    setFirstLoad(false);
    let isValid = true;
    let newError = err;

    if (!email && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      newError.email = false;
    } else if(email) {
      console.log("Invalid Email");
      isValid = false;
      newError.email = true;
    }

    if(name.length > 5) {
      newError.name = false;
    } else {
      isValid = false;
      newError.name = true;
    }

    if(/^[6-9]\d{9}$/.test(phone)) {
      newError.phone = false;
    } else {
      console.log("Invalid Phone");
      isValid = false;
      newError.phone = true;
    }

    if(question.length > 20) {
      newError.question = false;
    } else {
      isValid = false;
      newError.question = true;
    }
    setError(
      {
        ...err,
        ...newError
      }
    );

    if(isValid) {
      let reqBody = {
        question,
        email,
        phone: parseInt(phone),
        name
      };

      var requestOptions = {
        method: 'POST',
        body: JSON.stringify(reqBody),
      };

      fetch("https://bfemg81gie.execute-api.ap-south-1.amazonaws.com/prod/website/question",
        requestOptions)
        .then(response => response.json())
        .then(result => {
          setSubmitStatus(true);
          setEmail('');
          setPhone('');
          setQuestion('');
          setName('');
        })
        .catch(error => {
          setSubmitStatus(false);
        });
      }
  }

  return (
    <Form validated={!isFirstLoad && !err.email && !err.phone && !err.question && !err.phone}>
      <Form.Group controlId="fullName">
        <Form.Control
          type="text"
          isInvalid={err.name}
          placeholder="Enter your Full Name"
          onChange={e => setName(e.target.value)}
          value={name}
        />

        <Form.Control.Feedback
            type="invalid"
          >
            Please provide your full name.
          </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="email">
          <Form.Control
            type="email"
            isInvalid={err.email}
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <Form.Text className="text-muted">
            We'll not share your email with anyone else.
          </Form.Text>
          <Form.Control.Feedback
            type="invalid"
          >
            Please enter a valid email address.
          </Form.Control.Feedback>
       
        <Form.Control
          type="number"
          placeholder="Enter your phone"
          value={phone}
          isInvalid={err.phone}
          onChange={e => setPhone(e.target.value)}
        />
        <Form.Text className="text-muted">
          We'll not share your phone with anyone else.
        </Form.Text>

        <Form.Control.Feedback
            type="invalid"
          >
            Please enter a valid phone number.
          </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="query">
        <Form.Control
          as="textarea"
          rows={3}
          isInvalid={err.question}
          value={question}
          onChange={e => setQuestion(e.target.value)}
        />

        <Form.Control.Feedback
            type="invalid"
          >
            Please provide more details about your question.
          </Form.Control.Feedback>
      </Form.Group>

      {!isFirstLoad &&
        <Alert variant={submitStatus ? 'success': 'danger'}>
          {
          submitStatus ?
            t("Thanks for submitting your request. Our team will contact you soon.")
          :
            t("Failed to submit. Please retry after a while.")
          }
        </Alert>
      }

      <CustomButton title="Submit" onClick={submit}/>
    </Form>
  );
}

export default ContactForm;